import { Currency } from './invoice';

export enum ContractStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  TERMINATED = 'TERMINATED'
}

export interface Contract {
  id: string;
  companyId: string;
  counterpartyId: string;
  counterpartyName: string;
  contractNumber: string;
  title: string;
  startDate?: string;
  endDate?: string;
  status: ContractStatus;
  valueAmount?: number;
  currency?: Currency;
  notes?: string;
  fileName?: string;
  originalFileName?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateContractRequest {
  counterpartyId: string;
  contractNumber: string;
  title: string;
  startDate?: string;
  endDate?: string;
  status?: ContractStatus;
  valueAmount?: number;
  currency?: Currency;
  notes?: string;
}

export interface UpdateContractRequest extends CreateContractRequest {}

